var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR12324LogoCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1695",
    "data-name": "Ret\\xE2ngulo 1695",
    width: 276.309,
    height: 64.896,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3894",
    "data-name": "Grupo 3894",
    transform: "translate(-1369 -930)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1668",
    "data-name": "Ret\\xE2ngulo 1668",
    width: 285,
    height: 128,
    transform: "translate(1369 930)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3918",
    "data-name": "Grupo 3918",
    transform: "translate(1372 961.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1784",
    "data-name": "Caminho 1784",
    d: "M23.8,22.259V28.9H2.873V1.086H23.8V7.505H11.248V11.54H21.4v6.174H11.248v4.545Z",
    transform: "translate(-1.742 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1785",
    "data-name": "Caminho 1785",
    d: "M83.831,1.086l-8.086,12.9L85.115,28.9H75.179l-5.136-8.76L64.858,28.9H57.044L66,14.539,57.411,1.086H67.37l4.316,7.486,4.479-7.486Z",
    transform: "translate(-34.582 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1786",
    "data-name": "Caminho 1786",
    d: "M140.725,7.75V28.9h-8.09V7.75h-5.768V1.085h19.625V7.75Z",
    transform: "translate(-76.91 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1787",
    "data-name": "Caminho 1787",
    d: "M203.792,22.259V28.9H182.863V1.086h20.929V7.505H191.239V11.54h10.148v6.174H191.239v4.545Z",
    transform: "translate(-110.856 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3917",
    "data-name": "Grupo 3917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3916",
    "data-name": "Grupo 3916",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1788",
    "data-name": "Caminho 1788",
    d: "M268.383,28.9h-6.949l-7.618-12.29a46.774,46.774,0,0,1-2.958-5.745,19.36,19.36,0,0,1,.673,4.565V28.9H244.6V1.086h8.07l6.481,10.188a39.406,39.406,0,0,1,2.934,5.34,40.437,40.437,0,0,1-.652-7.3V1.086h6.949Z",
    transform: "translate(-148.284 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1789",
    "data-name": "Caminho 1789",
    d: "M310.016,20.194l7.927-1.427q1,3.363,5.135,3.363,3.22,0,3.22-1.712a1.588,1.588,0,0,0-.744-1.4,7.981,7.981,0,0,0-2.66-.886q-7.317-1.4-9.4-3.664a7.614,7.614,0,0,1-2.078-5.321,8.325,8.325,0,0,1,2.986-6.543Q317.392,0,323,0q8.5,0,11.229,6.826l-7.071,2.14a4.325,4.325,0,0,0-4.463-2.792q-2.792,0-2.792,1.733a1.368,1.368,0,0,0,.632,1.2,7.711,7.711,0,0,0,2.445.814,51.6,51.6,0,0,1,7.093,1.868,7.645,7.645,0,0,1,3.5,2.78,7.775,7.775,0,0,1,1.405,4.639,8.218,8.218,0,0,1-3.424,6.841,14.39,14.39,0,0,1-8.986,2.62q-10.17,0-12.553-8.477",
    transform: "translate(-187.94 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1692",
    "data-name": "Ret\\xE2ngulo 1692",
    width: 8.539,
    height: 27.817,
    transform: "translate(150.3 0.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1790",
    "data-name": "Caminho 1790",
    d: "M436.242,1.086,427.611,28.9h-8.7L409.883,1.086h9l4.4,15.162q.45,1.345.8,2.649l5.14-17.81Z",
    transform: "translate(-248.481 -0.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1791",
    "data-name": "Caminho 1791",
    d: "M491.524,28.672a12.6,12.6,0,0,1-9.568-3.892q-3.7-3.892-3.7-10.413a15.129,15.129,0,0,1,3.536-10.3Q485.329,0,491.605,0a12.5,12.5,0,0,1,9.465,3.831q3.659,3.832,3.658,10.23,0,6.623-3.689,10.617a12.364,12.364,0,0,1-9.516,3.994m-.041-6.317a3.229,3.229,0,0,0,3.108-1.885q.947-1.885.947-6.9,0-7.255-3.892-7.255-4.2,0-4.2,8.274,0,7.764,4.035,7.764",
    transform: "translate(-289.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1792",
    "data-name": "Caminho 1792",
    d: "M22.377,111.312l-.319,7.106H0v-6.66L4.928,108.3q1.083-.742,4.047-3.191a22.339,22.339,0,0,0,3.866-3.766,4.8,4.8,0,0,0,.9-2.757,3.1,3.1,0,0,0-.787-2.216,2.7,2.7,0,0,0-2.064-.838q-3.193,0-3.575,5.005L0,99.117q.806-5.112,4-7.6a11.9,11.9,0,0,1,7.54-2.492,11.487,11.487,0,0,1,7.689,2.523,8.372,8.372,0,0,1,2.98,6.724,9.684,9.684,0,0,1-1.623,5.323q-1.622,2.525-9.492,7.72Z",
    transform: "translate(0 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1793",
    "data-name": "Caminho 1793",
    d: "M76.092,118.863a9.777,9.777,0,0,1-8.294-4.124q-3.054-4.126-3.054-10.85,0-6.892,3.128-10.88a10.093,10.093,0,0,1,8.368-3.987,9.6,9.6,0,0,1,8.42,4.253,18.758,18.758,0,0,1,2.927,10.869q0,6.745-3.15,10.732a10.105,10.105,0,0,1-8.346,3.987m.085-6.151q1.824,0,2.439-2.322a25.862,25.862,0,0,0,.615-6.352q0-5.536-.817-7.233a2.483,2.483,0,0,0-2.217-1.7q-1.7,0-2.344,2.239a23.145,23.145,0,0,0-.646,6.161,26.863,26.863,0,0,0,.646,7.265,2.391,2.391,0,0,0,2.323,1.941",
    transform: "translate(-39.249 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1794",
    "data-name": "Caminho 1794",
    d: "M151.756,111.312l-.319,7.106H129.379v-6.66l4.928-3.458q1.084-.742,4.048-3.191a22.386,22.386,0,0,0,3.866-3.766,4.8,4.8,0,0,0,.9-2.757,3.1,3.1,0,0,0-.787-2.216,2.7,2.7,0,0,0-2.064-.838q-3.193,0-3.575,5.005l-7.318-1.42q.806-5.112,4-7.6a11.892,11.892,0,0,1,7.54-2.492,11.487,11.487,0,0,1,7.689,2.523,8.372,8.372,0,0,1,2.98,6.724,9.684,9.684,0,0,1-1.623,5.323q-1.622,2.525-9.491,7.72Z",
    transform: "translate(-78.433 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1795",
    "data-name": "Caminho 1795",
    d: "M192.131,109.572l7.551-.933q.743,3.966,4.242,3.967a3.92,3.92,0,0,0,2.587-.828,2.743,2.743,0,0,0,1-2.227,2.639,2.639,0,0,0-.541-1.644,3.188,3.188,0,0,0-1.156-1,5.525,5.525,0,0,0-2.121-.286h-3.521v-6.045h2.969q2.376,0,3.054-.849a2.785,2.785,0,0,0,.679-1.76,2.461,2.461,0,0,0-.849-1.909A3.2,3.2,0,0,0,203.8,95.3q-2.97,0-3.627,3.309l-7-1.1a10.287,10.287,0,0,1,4.041-6.278,13.7,13.7,0,0,1,14.943.021,7.128,7.128,0,0,1,2.884,5.939,6.362,6.362,0,0,1-1.22,3.882,5.914,5.914,0,0,1-3.107,2.226q5.218,1.591,5.218,6.809a7.521,7.521,0,0,1-3.171,6.459,13.662,13.662,0,0,1-8.219,2.3q-10.138,0-12.407-9.29",
    transform: "translate(-116.475 -53.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1693",
    "data-name": "Ret\\xE2ngulo 1693",
    width: 10.753,
    height: 6.66,
    transform: "translate(101.193 48.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1796",
    "data-name": "Caminho 1796",
    d: "M311.461,111.312l-.318,7.106H289.085v-6.66l4.928-3.458q1.083-.742,4.047-3.191a22.336,22.336,0,0,0,3.866-3.766,4.794,4.794,0,0,0,.9-2.757,3.1,3.1,0,0,0-.788-2.216,2.7,2.7,0,0,0-2.063-.838q-3.193,0-3.576,5.005l-7.317-1.42q.806-5.112,4-7.6a11.9,11.9,0,0,1,7.541-2.492,11.483,11.483,0,0,1,7.688,2.523,8.37,8.37,0,0,1,2.98,6.724,9.684,9.684,0,0,1-1.623,5.323q-1.622,2.525-9.491,7.72Z",
    transform: "translate(-175.251 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1797",
    "data-name": "Caminho 1797",
    d: "M365.177,118.863a9.775,9.775,0,0,1-8.293-4.124q-3.054-4.126-3.054-10.85,0-6.892,3.128-10.88a10.093,10.093,0,0,1,8.368-3.987,9.6,9.6,0,0,1,8.42,4.253,18.757,18.757,0,0,1,2.927,10.869q0,6.745-3.149,10.732a10.107,10.107,0,0,1-8.346,3.987m.085-6.151q1.824,0,2.439-2.322a25.865,25.865,0,0,0,.615-6.352q0-5.536-.816-7.233a2.483,2.483,0,0,0-2.217-1.7q-1.7,0-2.344,2.239a23.109,23.109,0,0,0-.647,6.161,26.822,26.822,0,0,0,.647,7.265,2.39,2.39,0,0,0,2.323,1.941",
    transform: "translate(-214.501 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1798",
    "data-name": "Caminho 1798",
    d: "M440.841,111.312l-.318,7.106H418.465v-6.66l4.928-3.458q1.083-.742,4.047-3.191a22.339,22.339,0,0,0,3.866-3.766,4.794,4.794,0,0,0,.9-2.757,3.1,3.1,0,0,0-.788-2.216,2.7,2.7,0,0,0-2.063-.838q-3.193,0-3.576,5.005l-7.317-1.42q.806-5.112,4-7.6A11.9,11.9,0,0,1,430,89.021a11.483,11.483,0,0,1,7.688,2.523,8.37,8.37,0,0,1,2.98,6.724,9.684,9.684,0,0,1-1.623,5.323q-1.622,2.525-9.491,7.72Z",
    transform: "translate(-253.684 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1799",
    "data-name": "Caminho 1799",
    d: "M506.014,112.054h-4.072v6.363h-7.975v-6.363H482.132v-6.3l10.9-16.734h8.908v16.734h4.072Zm-12.047-6.3V97.107l-5.481,8.648Z",
    transform: "translate(-292.281 -53.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1694",
    "data-name": "Ret\\xE2ngulo 1694",
    width: 56.413,
    height: 64.451,
    transform: "translate(219.895 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1800",
    "data-name": "Caminho 1800",
    d: "M586.67,49.375l8.688,16.932h-9.192l-7.472-15.419h-1.156V66.307h-8.392V8.129h12.217q11.179.03,11.179,12.246V38.641q0,7.711-5.871,10.734m-9.133-33V42.882h1.928a8.082,8.082,0,0,0,2.4-.237,3.6,3.6,0,0,0,2.283-3.707V20.346q0-3.973-3.648-3.974Z",
    transform: "translate(-345.03 -4.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1801",
    "data-name": "Caminho 1801",
    d: "M655.661,64.937V15.329L647.8,16.812V8.835l16.25-2.965V64.937Z",
    transform: "translate(-392.715 -3.558)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR12324LogoCard);
export default __webpack_public_path__ + "static/media/extensivoR12324LogoCard.9664d687e2e61ca9e3590ea7cbf21173.svg";
export { ForwardRef as ReactComponent };